<template>
  <div>
    <div class="row border-bottom white-bg dashboard-header mb-3">
      <div class="col-md-5">
        <el-page-header
          style="padding: 10px 0;"
          @back="handleBack"
          content="Automated Email Template Editor"
        ></el-page-header>
      </div>
    </div>
    <br />
    <loader v-if="loading" msg="Loading email template" />
    <template-editor
      v-else
      :template="template"
      @onCancel="handleCancel"
      @onSave="handleSave">
    </template-editor>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader';
import TemplateEditor from '@/components/automatedemails/templates/TemplateEditor';
import getTemplateQuery from '@/graphql/automatedemails/templates/emailTemplateGetQuery.gql';
import updateTemplateMutation from '@/graphql/automatedemails/templates/emailTemplateUpdateMutation.gql';

export default {
  name: 'EmailComposerContainer',
  computed: {
    editing() {
      return this.$router.currentRoute.params.id !== 'new';
    },
  },
  data: () => ({
    template: {
      name: null,
    },
    loading: false,
  }),
  components: {
    TemplateEditor,
    Loader,
  },
  mounted() {
    if (this.editing) this.getEmail();
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
    handleSave({ id, ...email }) {
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: updateTemplateMutation,
          variables: { id, data: { ...email } },
        })
        .then(() => {
          this.$notify({
            title: 'Success!',
            message: 'Template successfully updated!',
            type: 'success',
          });

          this.$router.push({ path: '/admin/templates' });
        })
        .catch(err => {
          this.$message.error(`Something went wrong -- ${err.message}`);
        });
    },
    handleCancel() {
      const path = '/admin/templates';
      this.$router.push({ path });
    },
    getEmail() {
      this.loading = true;
      const id = parseInt(this.$router.currentRoute.params.id, 10);
      this.$apollo
        .query({
          client: 'apiv2',
          query: getTemplateQuery,
          variables: {
            id,
          },
        })
        .then(({ data }) => {
          this.template = data.template;
          this.template.id = parseInt(this.template.id, 10);
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// EmailComposerContainer.vue?725aa2bb